<template>
    <b-card>
        <b-card-header class="bg-info">
            <h4 class="title">ویرایش دسترسی</h4>
        </b-card-header>
        <b-card-body>
            <b-overlay :show="!permission">
                <b-form @submit.prevent>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group>
                                <label for="name">
                                    <feather-icon
                                            icon="FeatherIcon"
                                    />
                                    نام دسترسی
                                </label>
                                <b-form-input
                                        v-model="permissionName"
                                        placeholder="نام دسترسی را وارد نمایید"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group>
                                <label for="name">
                                    <feather-icon
                                            icon="FeatherIcon"
                                    />
                                    نام فارسی دسترسی
                                </label>
                                <b-form-input
                                        v-model="slug"
                                        placeholder="نام فارسی دسترسی را وارد نمایید"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-form>
            </b-overlay>
            <button class="btn btn-info" @click="updatePermission">ذخیره دسترسی</button>
        </b-card-body>
    </b-card>
</template>

<script>
import {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay
} from 'bootstrap-vue'
import VSelect from 'vue-select'

export default {
    name: 'Permissions_Update',
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BForm,
        BFormGroup,
        BFormInput,
        VSelect,
        BOverlay
    },
    data() {
        return {
            permissionName: '',
            slug: '',
            permissionList: [],
            permission: false
        }
    },
    methods: {
        updatePermission() {
            if (this.permissionName === '') {
                this.$bvToast.toast('نام دسترسی نمیتواند خالی باشد', {
                    title: 'خطا',
                    toaster: 'b-toaster-top-right',
                    variant: 'danger'
                })
                return false
            }
            if (this.slug === '') {
                this.$bvToast.toast('نام فارسی دسترسی نمیتواند خالی باشد', {
                    title: 'خطا',
                    toaster: 'b-toaster-top-right',
                    variant: 'danger'
                })
                return false
            }

            let id = this.permission.id
            this.permission = false
            this.$http.put(`user/permissions/${this.$route.params.id}`, {
                name: this.permissionName,
                slug: this.slug,
                permissions: this.permissions,
                id
            })
                .then(({data}) => {
                    if (data.status) {
                        this.$bvToast.toast('دسترسی با موفقیت اصلاح شد', {
                            title: 'موفقیت',
                            toaster: 'b-toaster-top-right',
                            variant: 'success',
                        })

                        this.getPermission()

                    } else {
                        this.$bvToast.toast('در اصلاح دسترسی خطایی رخ داده', {
                            title: 'حطا',
                            toaster: 'b-toaster-top-right',
                            variant: 'danger',
                        })
                    }
                })
                .catch(() => {
                    this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
                        title: 'خطا در دریافت اطلاعات',
                        toaster: 'b-toaster-top-right',
                        variant: 'danger'
                    })
                })
        },

        getPermission() {
            this.$http.get(`user/permissions/${this.$route.params.id}`)
                .then(({data}) => {
                    if (data.status) {
                        this.permission = data.permission
                        this.permissionName = data.permission.name
                        this.slug = data.permission.slug
                    } else {
                        this.$bvToast.toast('دریافت دسترسی با خطا مواجه شد', {
                            title: 'خطا در دریافت اطلاعات',
                            toaster: 'b-toaster-top-right',
                            variant: 'danger'
                        })
                    }

                })
                .catch(() => {
                    this.$bvToast.toast('ارتباط با وبسرویس انجام نشد', {
                        title: 'خطا در دریافت اطلاعات',
                        toaster: 'b-toaster-top-right',
                        variant: 'danger'
                    })
                })
        }
    },
    mounted() {
        this.getPermission()
    }
}
</script>

<style>

</style>